export const isHtmlEmpty = (html) => {
  if (!html || typeof html !== "string") {
    return true;
  }

  const document = new DOMParser().parseFromString(html, "text/html");
  const text = document.body.textContent || "";

  return text.trim().length === 0;
};